export default "__VITE_ASSET__DVrwHxUc__"